import { useRef, useState } from 'react'

import data from '../../../../api/adminMenu.json'
import classes from './Menu.module.scss'

import List from './List'
import Links from './Link'
import Masonry from 'react-masonry-css'
import Image from '../../../../components/IPImage'
import { logoutUser } from '../../../../base/proxy/authenticate'
import { Link } from 'react-router-dom'
import Translations from '../../../../translations'
import { translate } from '../../../../base/localization'
import { currentUser } from '../../../../redux/slices/user/userSlice'
import { useAppDispatch, useAppSelector } from '../../../../redux/app/hooks'
import { initialize } from 'react-ga'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../base/customHooks/componentHOC'
import IPButton from '../../../../components/IPButton'
import IPSelectBox, { ISelectOption } from '../../../../components/IPSelectBox/IPSelectBox'
import { OpenTicketApi } from './openTicketApi'
import Swal from 'sweetalert2'
import IPModal from '../../../../components/IPModal'
import IPInput from '../../../../components/IPInput'
import IPTextarea from '../../../../components/IPTextarea'
import { getUploadFileRequest } from '../../../../base/utils/dataHelper'
import { PostDocApi } from '../../../../pages/Admin/ProductOperation/VisualDocumentationCrud/services/postDocApi'

function Menu(props: BaseComponentWithContextProps) {
  const inputElf: any = useRef(null)
  const t = translate(Translations)
  const inputEl = useRef<HTMLInputElement>(null)
  const searchButton = useRef(null)
  const menuButton = useRef(null)

  const logout = async () => {
    try {
      props.showLoading()
      await logoutUser()
      props.hideLoading()
    } catch { }
  }

  const [isMenuActive, setIsMenuActive] = useState(false)
  const [isSearchActive, setIsSearchActive] = useState(false)
  const [search, setSearch] = useState('')
  const [title, setTitle] = useState('')
  const [text, setText] = useState('')
  const [depart, setDepart] = useState<ISelectOption>()
  const [link, setLink] = useState('')
  const [ticketModal, setTicketModal] = useState(false)
  const [company, setCompany] = useState<ISelectOption>()

  // JİRA ŞİRKET COMPANY OPTİONS

  const companyOptions = [
    { value: "Indexgrup", label: 'Index Grup' },
    { value: "Index", label: 'Index' },
    { value: "Despec", label: 'Despec' },
    { value: "Datagate", label: 'Datagate' },
    { value: "Neteks", label: 'Netex' },
  ]

  const departOptions = [
    { value: "Bilgi Sistemleri", label: "Bilgi Sistemleri" },
    { value: "Cari Hesaplar", label: "Cari Hesaplar" },
    { value: "Dış Ticaret", label: "Dış Ticaret" },
    { value: "Elektronik Satış", label: "Elektronik Satış" },
    { value: "E-Ticaret", label: "E-Ticaret" },
    { value: "Finans", label: "Finans" },
    { value: "Hukuk", label: "Hukuk" },
    { value: "It", label: "It" },
    { value: "İç Denetim", label: "İç Denetim" },
    { value: "İdari İşler", label: "İdari İşler" },
    { value: "İnsan Kaynakları", label: "İnsan Kaynakları" },
    { value: "İthalat", label: "İthalat" },
    { value: "Kurumsal İletişim", label: "Kurumsal İletişim" },
    { value: "Muhasebe", label: "Muhasebe" },
    { value: "Satış", label: "Satış" },
    { value: "Teklos", label: "Teklos" },
    { value: "Ürün Yönetimi", label: "Ürün Yönetimi" },
    { value: "Yönetim", label: "Yönetim" },
    { value: "Şirket Dışı", label: "Şirket Dışı" },
    { value: "Info", label: "Info" }
  ];


  const user = useAppSelector(currentUser)
  const dispatch = useAppDispatch()

  const handleMenu = () => {
    setIsMenuActive(!isMenuActive)
  }

  const Jira = async () => {
    if (!title || !text || !company || !depart) {
      return Swal.fire({
        icon: 'error',
        title: "Bütün alanların doldurulması zorunludur.",
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
    let req = {
      Title: title,
      Text: text,
      Company: company?.value,
      Link: link,
      Depart: depart?.value
    }

    try {
      props.showLoading()
      const res = await new OpenTicketApi({}).openTicket(req)
      if (res) {
        props.hideLoading()
        setText('')
        setTitle('')
        setDepart(undefined)
        setLink('')
        setCompany(undefined)
        setTicketModal(false)
        Swal.fire({
          icon: 'success',
          title: res,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      }
    }
    catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }

  }

  const closeOnEscape = e => {
    const key = e.key || e.keyCode
    if (key === 'Escape' || key === 'Esc' || key === 27) {
      setIsSearchActive(false)
    }
  }

  const toggleSearch = () => {
    if (!isSearchActive) {
      setIsSearchActive(true)
      setIsMenuActive(true)
      setTimeout(() => inputEl.current!.focus(), 100)
    } else setIsSearchActive(false)
  }

  const handleClose = e => {
    if ([inputEl.current, searchButton.current, menuButton.current, undefined, null].indexOf(e.target) > -1) return
    setIsSearchActive(false)
    setIsMenuActive(false)
  }

  const handleSearch = e => {
    setSearch(e.target.value)
  }

  const handleSubMenuSearch = () => {
    if (search) {
      let tempResult: any = []
      let tempSubMenuArray: any = []

      for (const item of data.menu) {
        tempSubMenuArray = []
        tempSubMenuArray = item.subMenu.filter((elem: any) => {
          return elem.name?.toLowerCase().includes(search?.toLowerCase())
        })
        // const founded = item.subMenu.find((elem: any) => { return elem.name.toLowerCase().includes(search.toLowerCase()) })

        // if (founded) {
        // }

        // for (const menu of item.subMenu) {
        //   if (menu.name.toLowerCase().includes(search.toLowerCase())) {
        //     let temSubMenuObj: any = {
        //       id: menu.id,
        //       name: menu.name,
        //       link: menu.link
        //     }
        //     tempSubMenuArray.push(temSubMenuObj)
        //   }
        // }
        let tempObj: any = {
          id: item.id,
          name: item.name,
          link: item.link,
          subMenu: tempSubMenuArray,
        }
        tempResult.push(tempObj)
      }
      if (tempResult.length > 0) {
        return tempResult
      } else {
        return []
      }
    } else {
      return data.menu
    }
  }

  const handleImageFileUpload = async (e: any) => {
    const fileList: any[] = await getUploadFileRequest(e)
    for (const fileData of fileList) {
      if (fileData.size > 50000000) {
        return Swal.fire('Hata', 'Her resim 50 MB\'den küçük olmalıdır!', 'error')
      }

      const allowedTypes = ['.jpeg', '.png', '.gif', '.jpg', '.vnd.openxmlformats-officedocument.wordprocessingml.document', '.xlsx', '.pdf', '.mp4'];
      if (!allowedTypes.includes(fileData.Extension)) {
        return Swal.fire('Hata', 'Hatalı dosya formatı! Sayfayı yeniledikten sonra tekrar deneyiniz.', 'error')
      }
      if (fileData.Extension === '.vnd.openxmlformats-officedocument.wordprocessingml.document')
        fileData.Extension = ".docx"
    }

    // Create the Files array from the fileList array
    const data = {
      Files: fileList.map((fileData, index) => ({
        Id: index,
        Label: '',
        Description: '',
        File: fileData,
      })),
    }

    const postImage: PostDocApi = new PostDocApi({})
    postImage
      .addDoc(data)
      .then((result: any) => {
        setLink(link + " " + result + " ")
        Swal.fire({
          icon: 'success',
          title: result,
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  return (
    <div className={classes.Menu} onClick={handleClose}>
      <nav>
        <div className={classes.menuBar}>
          <Link to='/homepage'>
            <Image className={classes.imglogo} src='/images/indexPazarLogo.png' alt='' />
          </Link>

          <div className={classes.linkWrapper}>
            <div className={classes.innerLinkWrapper}>
              <Links
                link='/admin/home'
                text='YÖNETİM PANELİ'
                iconSrcBlack='/images/Anasayfa.png'
                iconSrcWhite='/images/AnasayfaBeyaz.png'
              />
              <Links
                link='/admin/dashboard'
                text='DASHBOARD'
                iconSrcBlack='/images/DashboardIkon.png'
                iconSrcWhite='/images/Dashboard.png'
              />
              <Links
                link='/admin/HomeAndSiteOperation/SAPUpdate'
                text='SAP GÜNCELLEME'
                iconSrcBlack='/images/sapguncelleme.png'
                iconSrcWhite='/images/sapguncellemebeyaz.png'
              />
              <Links
                link='/admin/UserOperation/ListUser'
                text='KULLANICILAR'
                iconSrcBlack='/images/KullaniciGuncelleme.png'
                iconSrcWhite='/images/KullaniciGuncellemeBeyaz.png'
              />
              <Links
                link='/admin/ProductOperation/DocumentUpload'
                text='DOSYA YÜKLEME'
                iconSrcBlack='/images/dokumanyukle.png'
                iconSrcWhite='/images/dokumanyuklebeyaz.png'
              />
              <Links
                link='/admin/ProductOperation/VisualDocumentationList'
                text='ÜRÜN GÖRSEL YÜKLEME'
                iconSrcBlack='/images/gorselguncelleme.png'
                iconSrcWhite='/images/gorselguncellemebeyaz.png'
              />
              <Links
                link='/admin/BankAndInstallementOperation/BankCrud'
                text='BANKA TAKSİT'
                iconSrcBlack='/images/BankaTaksitGuncelleme.png'
                iconSrcWhite='/images/BankaTaksitGuncellemeBeyaz.png'
              />
              <Links
                link='/admin/ProductOperation/CampaignBundleList'
                text='KAMPANYALAR'
                iconSrcBlack='/images/BundleEkleme.png'
                iconSrcWhite='/images/BundleEklemeBeyaz.png'
              />
              <Links
                link='/admin/HomeAndSiteOperation/AnnouncementList'
                text='DUYURULAR'
                iconSrcBlack='/images/DuyuruListesi.png'
                iconSrcWhite='/images/DuyuruListesiBeyaz.png'
              />
              <IPButton
                type='button' className='btn btn-primary'
                style={{ width: '5%', borderRadius: '1rem', marginLeft: '5px' }}
                onClick={() => { setTicketModal(true) }}
                text={'TALEP OLUŞTUR'} />
            </div>
            <input
              ref={inputEl}
              className={`${classes.searchInput} ${isSearchActive ? classes.active : ''}`}
              onChange={handleSearch}
              type='text'
              placeholder={t('layouts.admin.search')}
              onKeyDown={closeOnEscape}
            />
          </div>
        </div>

        {/* <Links
          className={classes.favoriteLink}
          link="/"
          text={t("layouts.admin.addFavorite")}
          iconSrc="/images/products/plusicon.png"
        />         */}

        <div className={classes.actions}>
          <div className={classes.searchButton}>
            <img src='/images/admin/magnifying-glass-solid.svg' alt='' ref={searchButton} onClick={toggleSearch} />
          </div>
          <div className={classes.ProfilImage}>
            <div className='topbar-dropdown p-dropdown'>
              <div className='row align-items-center'>
                <div className='col-auto'>
                  <div className='title p-0 float-right profileTitle'>
                    <a href=''>
                      <Image
                        className='avatar'
                        src={
                          user.DealerLogo
                            ? user.DealerLogo === 'https://index-content.vbt.com.tr:1443/'
                              ? '/images/notImage.png'
                              : user.DealerLogo
                            : '/images/notImage.png'
                        }
                        alt=''
                        style={{ marginRight: '0' }}
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className='p-dropdown-content'>
                <div className={classes.profilbutton}>
                  <ul className='text-center' style={{ paddingLeft: 'initial' }}>
                    <li>
                      <Link to='/'>
                        {' '}
                        <i className='fa fa-desktop'></i>
                        {t('layouts.admin.goToTheSite')}
                      </Link>
                    </li>
                    <li>
                      <Link to='/myspecial'>
                        {' '}
                        <i className='icon-user'></i>
                        {t('layouts.admin.myProfile')}
                      </Link>
                    </li>
                    <li>
                      <a role={'button'}
                        onClick={() => setTicketModal(true)}>
                        <i className='icon-edit'></i>
                        {"Talep Oluştur"}
                      </a>
                    </li>
                    <li>
                      <a role={'button'} onClick={logout}>
                        <i className='icon-clock'></i>
                        {t('layouts.admin.logout')}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav >

      <div className={`${classes.megaMenu} ${isMenuActive ? classes.active : ''}`}>
        <Masonry
          breakpointCols={4}
          scrolling='origin'
          className={classes['my-masonry-grid']}
          columnClassName={classes['my-masonry-grid_column']}
        >
          {handleSubMenuSearch().map((dataList: any) => (
            <div key={dataList.id} className={classes.dataList}>
              <List key={dataList.id} dataList={dataList} />
            </div>
            // <div className="asdasdas" key={index}>{dataList.subMenu.name}</div>
          ))}
        </Masonry>
      </div>
      <IPModal
        width={1000}
        height={700}
        show={ticketModal}
        hideConfirm={false}
        confirmText='Kaydet'
        title={'Jira Talep Oluştur'}
        onClose={() => {
          setTicketModal(false)
          setText('')
          setTitle('')
          setDepart(undefined)
          setLink('')
          setCompany(undefined)
        }}
        onConfirm={() => {
          Jira()
        }}
        closeOnEscapeKey={true}
      >
        <div className='container'>
          <div className='row mt-3'>
            <div className='col-lg-3'>
              <label>Şirketiniz</label>
              <IPSelectBox
                id='company'
                name='company'
                options={companyOptions}
                value={company}
                onChangeSingle={option => setCompany((option))}
              />
            </div>
            <div className='col-lg-3'>
              <label>Departmanınız</label>
              <IPSelectBox
                id='depart'
                name='depart'
                options={departOptions}
                value={depart}
                onChangeSingle={option => setDepart((option))}
              />
            </div>
            <div className='col-lg-6'>
              <label>Başlık</label>
              <IPInput
                type='text'
                id='title'
                name='title'
                value={title}
                onChange={e => setTitle(e.target.value)}
              />
            </div>
          </div>
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label>Açıklama</label>
              <IPTextarea
                id='text'
                name='text'
                style={{ height: '300px' }}
                value={text}
                onChange={e => setText(e.target.value)}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <label style={{ margin: 0 }}>Linkler</label>
                <IPButton
                  type="button"
                  className='btn btn-success'
                  style={{ width: '5%' }}
                  onClick={() => inputElf.current.click()}
                  text={'Dosya Yükle'}
                />
              </div>
              <label style={{ color: 'red' }}>
                Birden fazla dosya linki için boşluk bırakarak yazınız.
              </label>
              <input
                ref={inputElf}
                type="file"
                name="mobilImage"
                className="form-control"
                id="mobilImage"
                style={{ display: 'none' }}
                onChange={event => {
                  handleImageFileUpload(event)
                }}
              />
              <IPInput
                id='links'
                name='links'
                value={link}
                onChange={e => setLink(e.target.value)}
                type='text'
              />
            </div>
          </div>
        </div>
      </IPModal >
    </div >
  )
}

export default componentWithContext(Menu)
